import { useChatPage } from "../-hooks/useChatPage";
import { composerInsetTransition } from "../-utils/composerLayoutHeight";
import { ComposerGradualBlur } from "./ComposerGradualBlur";

export function HostComposerInset() {
    const { composerHeight } = useChatPage();
    // Stacked backdrop-filters are expensive in the iOS web view. The native
    // composer already covers this strip.
    const showsBlur = window.isIosNativeWebView !== true;

    return (
        <div
            className="pointer-events-none absolute inset-x-0 bottom-0 z-10"
            style={{
                height: composerHeight,
                transition: composerInsetTransition("height"),
            }}
            data-viewport-obstacle
        >
            {showsBlur ? <ComposerGradualBlur height={composerHeight} /> : null}
        </div>
    );
}
